const extractAddressParts = (components = []) => {
    const result = {};

    components.forEach(c => {
        if (c.types.includes("locality"))
            result.city = c.longText;
        if (c.types.includes("administrative_area_level_1"))
            result.state = c.shortText;
        if (c.types.includes("postal_code"))
            result.postalCode = c.longText;
        if (c.types.includes("sublocality"))
            result.sublocality = c.longText;
        if (c.types.includes("administrative_area_level_2"))
            result.county = c.longText;
    });

    return result;
}

export default extractAddressParts;